import { ScrollText } from 'lucide-react';
import { useT } from '../../i18n';
import { SetupCard } from '../ui';

/**
 * THE «LOGG» ENTRY IN THE ORGANIZATION'S SETTINGS (#935, 2026-11-01).
 *
 * Its own component for the reason `AccessSettingsCard` is: the settings view
 * is a legacy surface whose render-contract tests mount it without a locale
 * provider, and this text is a catalog key. Rendered only for somebody whose
 * capability union here holds `organization.audit.read` — Eier and
 * Administrator by default — or StarPoint acting as the organization, so
 * nobody else sees a door the server would refuse.
 */
export function AuditLogSettingsCard({ onOpen }: { onOpen: () => void }) {
  const t = useT();
  return (
    <SetupCard label={t('clubSettings.auditLog.title')}>
      <div className="flex flex-col gap-3">
        <p className="text-sm text-ink-2">{t('clubSettings.auditLog.lead')}</p>
        <button
          type="button"
          onClick={onOpen}
          className="btn-outline text-xs self-start inline-flex items-center gap-1.5"
          data-testid="club-settings-open-audit-log"
        >
          <ScrollText size={12} /> {t('clubSettings.auditLog.open')}
        </button>
      </div>
    </SetupCard>
  );
}
